import Check from "./check.page";

export default Check;
